import { Outlet } from "react-router";
import { TitleManager } from "@common/components/TitleManager";
import BridgeUpgradeBanner from "@/features/bridge-upgrade/BridgeUpgradeBanner";

/**
 * Pathless root layout shared by the authenticated and unauthenticated route trees. Exists so
 * route-wide concerns have a single mount point inside router context, and renders the matched
 * route via <Outlet />.
 *
 * `BridgeUpgradeBanner` is here rather than beside `<RouterProvider>` in `app.tsx`, where the other
 * app-wide banners sit. Above the router it had no `useLocation` or `useNavigate`, which cost an
 * external store to push the location out to it, a hard `window.location.assign` to navigate, and a
 * `runWhenRecorderIdle` guard because that hard navigation tears down a live recording. Here it is
 * an ordinary component and all three are unnecessary. It still renders above <Outlet />, so it
 * paints in the same place.
 */
export function RootLayout() {
    return (
        <>
            <TitleManager />
            <BridgeUpgradeBanner />
            <Outlet />
        </>
    );
}
